import { defineMessages } from '@cookbook/solid-intl'

// Split out of `home-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    guestDescriptionMessage: defineMessages({
        defaultMessage: 'Discover affordable short term rentals with Lodgr. Browse unique and affordable short term rental stays from cottages, vacation homes, cabins, condos, and apartments.',
        id: 'HomePage.guest.descriptionMessage',
    }),
    guestTitleMessage: defineMessages({
        defaultMessage: 'Canada’s Affordable Short Term Rental Platform | Lodgr',
        id: 'HomePage.guest.titleMessage',
    }),
}
